import { styled, tooltipClasses } from '@mui/material';
import { Tooltip as UITooltip, TooltipProps as UITooltipProps } from '@o2/ui';

const Tooltip = styled(UITooltip, {
  name: 'AppBar',
  slot: 'tooltip',
})(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    marginTop: '8px !important',
  },
}));

Tooltip.displayName = 'AppBar.Tooltip';

export interface TooltipProps extends UITooltipProps {
  'data-elm'?: string;
}

export default Tooltip;
